import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<BracketConfigEditor @config={{@model}} />\n",{ moduleName: "bullitt-time-live/templates/event/bracket-config-editor.hbs" })